import { atom } from "recoil";
import { Calendar, Dirary } from "../types/dirary";

export const currentDateState = atom<Date>({
  key: "currentDateState",
  default: new Date(),
});
